import React, { CSSProperties } from 'react'
import KeyboardControl from '../KeyboardControls/KeyboardControl'
import { useKeyboardControls } from '../../../contexts/KeyboardControlsContext'
import ControlHighlight from '../KeyboardControls/ControlHighlight'
import { HighlightEffect } from '../../../enums/KeyboardControls'
import { FocusableElement } from '../../organisms/Menu/StudentMenu'

interface OverlayModalProps {
  onClick?: () => void
  children: React.ReactNode
  overlayWidth?: string
  overlayHeight?: string
  showOverlay?: boolean
}

const OverlayMenuModal: React.FunctionComponent<OverlayModalProps> = ({
  onClick,
  children,
  overlayWidth = '90vw',
  overlayHeight = '85vh',
  showOverlay = true
}) => {
  const keyboardControls = useKeyboardControls()
  const baseContainerClasses = 'flex justify-center items-center'
  const overlayClasses = showOverlay ? 'fixed inset-0 bg-black bg-opacity-75 z-30' : ''

  const modalStyles: CSSProperties = showOverlay
    ? {
        width: overlayWidth,
        height: overlayHeight,
        maxWidth: 'calc(100vw - 40px)',
        maxHeight: 'calc(100vh - 40px)',
        minWidth: '670px',
        minHeight: '400px'
      }
    : {
        minWidth: '670px',
        minHeight: '400px'
      }

  return (
    <div
      data-testid='overlay-container'
      className={`${baseContainerClasses} ${overlayClasses}`}
    >
      <div className='glow-effect'>
        <div className='modal-container'>
          <div
            data-testid='modal-container'
            className='beveled-corner p-[4px] bg-dopage-lightGreen'
            style={modalStyles}
          >
            <div className='inner bg-black h-full'>
              <div className='p-[22px] flex flex-col items-center text-dopage-lightGreen h-full'>
                <div className='w-full h-full overflow-y-auto'>
                  {children}
                </div>
              </div>
            </div>
          </div>
          {showOverlay && (
            <div className='close-button-container absolute top-0 right-0'>
              <KeyboardControl>
                <ControlHighlight
                  active={keyboardControls.isEnabled && keyboardControls.isElementFocused(FocusableElement.CloseButton)}
                  highlightEffect={HighlightEffect.ButtonHexOutline}
                  className='close-highlight'
                >
                  <button
                    id={FocusableElement.CloseButton}
                    onClick={onClick}
                    aria-label='Close'
                    tabIndex={-1}
                    className='modal-close'
                  >
                    <span className='close-symbol' aria-hidden='true'>
                      ×
                    </span>
                  </button>
                </ControlHighlight>
              </KeyboardControl>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default OverlayMenuModal
